import { gql } from 'apollo-boost';

export const QUERY_FINANCE_PROGRAM_PUBLIC = gql`
  query FinanceProgramPublic($financeProgramId: ID!) {
    financeProgramPublic(financeProgramId: $financeProgramId) {
      insuranceCoverage {
        coverageRequirements
        certificateRequirements
        otherInstructions
      }
    }
  }
`;
